import { useTranslation } from 'react-i18next';

import { Tooltip } from '@amzn/storm-ui';

import { TooltipTriggerWrapper, TooltipTriggerText } from './ErrorTooltip.styles';

interface ErrorTooltipProps {
  message: string;
}

export const ErrorTooltip = ({ message }: ErrorTooltipProps) => {
  const { t } = useTranslation();

  if (!message || message.trim() === '') {
    return null;
  }

  return (
    <Tooltip
      message={message}
      position="top"
      variant="default"
      spacing={8}
      align="center"
      trigger={
        <TooltipTriggerWrapper>
          <TooltipTriggerText>{t('know-more')}</TooltipTriggerText>
        </TooltipTriggerWrapper>
      }
    />
  );
};
